import * as React from 'react'
import { connect } from 'react-redux'
import { history, IState } from 'store'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { ViewNotFound } from 'components/views/ViewNotFound'
import { ViewHome } from 'components/views/ViewHome'
import { ViewSimulation } from './views/ViewSimulation'
import { ViewExplore } from './views/ViewExplore'

interface Props {
  isLoggedIn: boolean
}

export const Routes = React.memo(({ isLoggedIn }: Props) => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route exact path="/" component={ViewHome} />
      <Route exact path="/simulation" component={ViewSimulation} />
      <Route exact path="/explore" component={ViewExplore} />
      <Route component={ViewNotFound} />
    </Switch>
  </ConnectedRouter>
))

const mapStateToProps = (state: IState) => ({
  isLoggedIn: !!state.app.currentUser.id,
})

export default connect(mapStateToProps)(Routes)
